/**
 * @license lucide v0.577.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

const MessageSquareDot = [
  [
    "path",
    {
      d: "M12.7 3H4a2 2 0 0 0-2 2v16.286a.71.71 0 0 0 1.212.502l2.202-2.202A2 2 0 0 1 6.828 19H20a2 2 0 0 0 2-2v-4.7"
    }
  ],
  ["circle", { cx: "19", cy: "6", r: "3" }]
];

export { MessageSquareDot as default };
//# sourceMappingURL=message-square-dot.js.map
